/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { BubbleType } from '@store/globalStore'
import BubblePopup from '@views/Matchup/BetSlip/Bubble'
//img
import { MessageIco } from '@shared/Icon/MenuIcon'
// css
import { Button } from '@styles/button.style'
import { BetSlipMessageBtnStyle } from './index.style'
import { BadgeStyle } from '@styles/base.style'
import { Badge } from 'antd-mobile'
import PopupUtils from '@utils/popup-utils'

const BetSlipMessageBtn: React.FC = () => {
  const { matchupStore, userStore, logStore } = useRootStore()
  const { notificationData } = userStore
  const { minimizeBetSlip } = matchupStore

  const onClickMessageBodyButton = () => {
    logStore.writeButtonLog({ pageId: 'f010', buttonId: '001' }).catch(console.error)
    PopupUtils.showMessagePopup()
  }

  return (
    <Fragment>
      {minimizeBetSlip &&
      <Fragment>
        <Button TP css={BetSlipMessageBtnStyle} onClick={onClickMessageBodyButton}>
          <MessageIco/>
          {notificationData.unreadMessageCount > 0 && <Badge dot css={BadgeStyle} className="message-badge"/>}
        </Button>
        <BubblePopup type={BubbleType.MESSAGE_ALERT}/>
      </Fragment>
      }
    </Fragment>
  )
}
export default observer(BetSlipMessageBtn)
